<template>
	<div v-if="['all-post'].indexOf($route.name) > -1"></div>
	<div id="sidebar_container" v-else>
		<div v-for="post in posts">
			<img class="paperclip" src="/static/main/img/paperclip.png" alt="paperclip" />
			<div class="sidebar">
				<a :href="'/#/posts/' + post.slug">
					<h3>{{ post.title }}</h3>
				</a>
				<h5>{{ post.created_at }}</h5>
				<p v-html="post.text_truncated">{{ post.text_truncated_short }}</p>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">

	module.exports = {
		data: function(){
			return {
				main: 'https://dnz-kalynka.pp.ua/api/posts/',
				posts: []
			}
		},
		methods: {
			getContent: function(){
				var options = {
					params: {
						limit: 5
					},
					headers: {
						'Content-Type' : 'application/json'
					}
				}

				this.$http.get(this.main, options).then(function(response){
					this.posts = response.data.results
				}, function(error){
					console.log('Помилка при отриманні даних')
				})
			}
		},
		created: function(){
			this.getContent()
		},
		watch: {
			'$route': {
				deep: true,
					handler: function (refreshPage) {
					this.getContent()
				}
			}
		}
	}

</script>


// WEBPACK FOOTER //
// src/views/sidebar.vue